import selectComponent from 'utilities/select-component'

export default class VideoModal {

    constructor(element) {
        this.$video = selectComponent(element)
        this.bindEvents()
    }

    bindEvents() {
        this.$video.on('click', () => {
            this.createPopup()
        })
    }

    bindContainerEvents() {
        this.$videoModal = selectComponent('video-modal')

        setTimeout(() => {
            this.$videoModal.addClass('-open')
        }, 10)

        this.$videoModal.on('click', () => {
            $('body').removeClass('-nav-open')

            this.$videoModal.removeClass('-open')
            
            setTimeout(() => {
                this.$videoModal.remove()
                this.$videoModal = null
            }, 250)
        })
    }

    createPopup() {
        $.ajax({
            type: 'GET',
            url: '/video-modal'
        })
        .done(( data, textStatus, jqXHR ) => {
            $('body').append(data).addClass('-nav-open')
            this.bindContainerEvents()
            this.insertVideo()
        })
    }

    insertVideo() {
        if (this.$video.data('service') == 'youtube') {
            const $content = $('<iframe>', {
                src: 'https://www.youtube.com/embed/' + this.$video.data('id') + '?rel=0',
                frameborder: 0,
                allowfullscreen: 'allowfullscreen'
            })
             .attr('width','560')
             .attr('height', '315')

            this.$videoModal.elements.content.append($content)
        }
    }
}